import LoyaltyProductsGrid from './LoyaltyProductsGrid'

export default LoyaltyProductsGrid
